import { BaseRepository } from '@/base/base-repository';
import { PriceResponseDto } from '@/dtos';

class PriceRepository extends BaseRepository {
	async getPrice(): Promise<PriceResponseDto> {
		const response = await this.httpClient({
			method: 'get',
			url: '/price',
		});
		return response.data;
	}
}

export const priceRepository = new PriceRepository();
